import React, { useState, useEffect } from 'react'
import { Activity, Clock, AlertCircle, CheckCircle, Info } from 'lucide-react'
import { apiFetch } from '../config'

const ActivityPage = () => {
  const [activities, setActivities] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchActivity()
  }, [])

  const fetchActivity = async () => {
    try {
      const response = await apiFetch("/activity?limit=50")
      const data = await response.json()
      setActivities(data)
      setLoading(false)
    } catch (error) {
      console.error('Failed to fetch activity:', error)
      setLoading(false)
    }
  }

  const getEventIcon = (type) => {
    switch (type) {
      case 'trade': return <CheckCircle className="w-5 h-5 text-success" />
      case 'sync': return <CheckCircle className="w-5 h-5 text-info" />
      case 'alert': return <AlertCircle className="w-5 h-5 text-warning" />
      case 'error': return <AlertCircle className="w-5 h-5 text-danger" />
      default: return <Info className="w-5 h-5 text-text-secondary" />
    }
  }

  const formatTime = (timestamp) => {
    const date = new Date(timestamp)
    return date.toLocaleTimeString('en-US', { 
      hour: '2-digit', 
      minute: '2-digit',
      hour12: false 
    })
  }

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-accent"></div>
      </div>
    )
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold">Activity Log</h1>
          <p className="text-text-secondary mt-1">
            Recent events from all agents
          </p>
        </div>
        
        <button 
          className="btn-secondary flex items-center gap-2"
          onClick={fetchActivity}
        >
          <Clock className="w-4 h-4" />
          Refresh
        </button>
      </div>

      <div className="card">
        <h2 className="text-lg font-semibold mb-4">Recent Events</h2>
        
        {activities.length === 0 ? (
          <div className="text-center py-12">
            <Activity className="w-12 h-12 mx-auto text-text-secondary mb-3" />
            <p className="text-text-secondary">No recent activity</p>
          </div>
        ) : (
          <div className="space-y-3">
            {activities.map((activity) => (
              <div 
                key={activity.id} 
                className="flex items-start gap-4 p-4 bg-surface-elevated rounded-lg border border-border"
              >
                <div className="mt-0.5">{getEventIcon(activity.event_type)}</div>
                
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between">
                    <h3 className="font-medium truncate">{activity.title}</h3>
                    <span className="text-xs text-text-muted">
                      {formatTime(activity.timestamp)}
                    </span>
                  </div>
                  
                  <p className="text-sm text-text-secondary mt-1">
                    {activity.message}
                  </p>
                  
                  <div className="flex items-center gap-3 mt-2 text-xs text-text-muted">
                    <span className="capitalize">{activity.event_type}</span>
                    <span>•</span>
                    <span className="capitalize">{activity.source}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default ActivityPage